<template>
  <div
    :class="disabled?`simplify-button${inputRadioClass}-disabled mt-4`
      :`simplify-button${inputRadioClass} mt-4`"
  >
    <label
      class="simplify-button-content"
      :for="`${name}-${formValue.toLowerCase().replace(/ /g, '-')}`"
    >
      <div class="simplify-radio-control">

        <input
          :id="`${name}-${formValue.toLowerCase().replace(/ /g, '-')}`"
          type="radio"
          :name="name"
          :value="formValue"
          :checked="value === formValue"
          :disabled="disabled"
          class="simplify-type-radio"
          style="pointer-events: none"
          @keyup.prevent="$emit('input', formValue)"
          @click="buttonClick"
        >


        <div class="simplify-button-text">
          <p
            v-if="title"
            class="simplify-button-title"
          >
            {{ title }}
          </p>
          <p
            v-if="description"
            class="simplify-button-description"
          >
            {{ description }}
          </p>
        </div>
      </div>
      <slot name="icon" />
    </label>
  </div>
</template>

<style>

.simplify-button * {
  cursor: pointer;
}

.simplify-button-selected *,
.simplify-button-disabled * {
  cursor: default;
}

.simplify-button, .simplify-button-selected,
.simplify-button-disabled, .simplify-button-selected-disabled {
  border-radius: 3px;
  display: flex;
  align-items: center;
  align-self: stretch;
}
.simplify-button, .simplify-button-selected {
  border: 1px solid #336;
}
.simplify-button-disabled {
  border: 1px solid #D8D8D8;
  cursor: default;
  background-color: #D8D8D8;
}

.simplify-button-selected > label > svg path,
.simplify-button-selected > label > svg path~polygon,
.simplify-button-selected-disabled > label > svg path,
.simplify-button-selected-disabled > label > svg path~polygon
{
  fill: #FFF;
}
.simplify__forward-type-label {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.simplify-type-radio {
  accent-color: #333366;
  display: flex;
  align-items: center;
  height: 15px;
}

 .simplify-button-title {
  font-size: 16px;
  line-height: 12px;
  font-weight: 700;
  margin-bottom: 8px;
}

.simplify-button .simplify-button-title {
  color: #336;
}
.simplify-button-disabled .simplify-button-title {
  color: #595959;
}

.simplify-button-description {
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
}
.simplify-button .simplify-button-description,
.simplify-button-disabled .simplify-button-description {
  color: #595959;
}

.simplify-button-selected,.simplify-button-selected-disabled {
  background: #333366;
  color: #FFF;
}

.simplify-button-content{
  gap: 5px;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  padding: 16px 20px;
}
.simplify-radio-control{
  display: flex;
  flex-grow: 2;
}
.simplify-button-text{
  margin-left: 15px;
}
.simplify-button-text p {
    text-align: left;
}

@media (max-width: 600px) {
  .simplify-button * {
    cursor: default;
  }
}
</style>

<script>

export default {
  name: 'SimplifyInputRadio',
  props: {
    title: {
      type: String,
      default: '',
      required: false,
    },
    description: {
      type: String,
      default: '',
      required: false,
    },
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    formValue: {
      type: String,
      required: true,
    },
    tabindex: {
      type: String,
      default: '0',
    },
    button: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    // update the base class based on prop boolean
    inputRadioClass() {
      return this.value === this.formValue ? '-selected' : '';
    },
  },
  methods: {
    buttonClick() {
      return this.disabled ? null : this.$emit('input', this.formValue);
    },
  },
};
</script>
